/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Subtitle_Max_Chars_HelpInputs */

const en_audio_description_export_subtitle_max_chars_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Characters per line`)
};

const fr_audio_description_export_subtitle_max_chars_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractères par ligne`)
};

const de_audio_description_export_subtitle_max_chars_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichen pro Zeile`)
};

const it_audio_description_export_subtitle_max_chars_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caratteri per riga`)
};

const ru_audio_description_export_subtitle_max_chars_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Символов в строке`)
};

const es_audio_description_export_subtitle_max_chars_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres por línea`)
};

const zh_cn2_audio_description_export_subtitle_max_chars_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每行字符数`)
};

const ja_audio_description_export_subtitle_max_chars_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行あたりの文字数`)
};

const hi_audio_description_export_subtitle_max_chars_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति पंक्ति वर्ण`)
};

const pt_pt2_audio_description_export_subtitle_max_chars_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres por linha`)
};

/**
* | output |
* | --- |
* | "Characters per line" |
*
* @param {Audio_Description_Export_Subtitle_Max_Chars_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_subtitle_max_chars_help = /** @type {((inputs?: Audio_Description_Export_Subtitle_Max_Chars_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Subtitle_Max_Chars_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_subtitle_max_chars_help(inputs)
	if (locale === "de") return de_audio_description_export_subtitle_max_chars_help(inputs)
	if (locale === "it") return it_audio_description_export_subtitle_max_chars_help(inputs)
	if (locale === "ru") return ru_audio_description_export_subtitle_max_chars_help(inputs)
	if (locale === "es") return es_audio_description_export_subtitle_max_chars_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_subtitle_max_chars_help(inputs)
	if (locale === "ja") return ja_audio_description_export_subtitle_max_chars_help(inputs)
	if (locale === "hi") return hi_audio_description_export_subtitle_max_chars_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_subtitle_max_chars_help(inputs)
	return en_audio_description_export_subtitle_max_chars_help(inputs)
});